import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './index.css';
import Link from '../../common/Link'
import { trackEventLog } from '../../../core/utils'

class Nav extends React.Component {

  static propTypes = {
    title: PropTypes.string.isRequired,
    sub: PropTypes.array.isRequired,
    fatherTag: PropTypes.object.isRequired,
    curTagId: PropTypes.number.isRequired,
  }

  render() {
    const { title, sub, curTagId, fatherTag } = this.props
    const navItems = sub.slice(0)
    if (navItems.length !== 0) {
      navItems.unshift({ id: fatherTag.id, name: '精选' })
    }
    return (
      <div className={s.root}>
        <Link
          className={s.title}
          to={`/tag/${fatherTag.id}`}
          extraParams={{ ptag: fatherTag.id }}
          onClick={() => { trackEventLog(`w/tag/click/${fatherTag.id}/${fatherTag.id}`) }}
        >{title}</Link>
        {
          sub ? navItems.map(tag => (
            <div
              key={`tag_nav_${tag.id}`}
              className={`${parseInt(curTagId, 10) === tag.id ? s.cur : ''} ${s.navItem}`}
            >
              <Link
                onClick={() => { trackEventLog(`w/tag/click/${fatherTag.id}/${tag.id}`) }}
                to={`/tag/${tag.id}`}
                extraParams={{ ptag: fatherTag.id }}
              >{tag.name}</Link>
              <div className={s.hoverIcon} />
            </div>)) : null
        }
      </div>
    );
  }
}

export default withStyles(s)(Nav);



// WEBPACK FOOTER //
// ./src/components/p_tag/Nav/index.js